import { resolveObstacleIllustrations } from "../../../frontend/src/utils/mineCartPlacement";
import { API_URL } from "./axios-config";
export function imageUrl(image) {
  if (!image) return "";
  return image.asset
    ? `/scenario-assets/${image.asset}`
    : image.url
      ? `${API_URL}${image.url}`
      : "";
}
export function setPath(object, key, value) {
  const parts = key.split(".");
  let dest = object;
  for (const part of parts.slice(0, -1)) dest = dest[part];
  dest[parts.at(-1)] = value;
}
export function resolvePreview(base, definition = {}) {
  const config = structuredClone(base);
  for (const group of ["assets", "colors", "strings"])
    for (const [key, value] of Object.entries(definition[group] || {})) {
      setPath(config, key, value);
      if (group === "assets" && key.endsWith(".source")) {
        const parent = key
          .slice(0, -7)
          .split(".")
          .reduce((v, k) => v?.[k], config);
        if (parent && typeof parent.ratio === "number")
          parent.ratio = value.width / value.height;
      }
    }
  if (definition.obstacleIllustrations)
    config.obstacleIllustrations = resolveObstacleIllustrations(
      config,
      definition.obstacleIllustrations,
      (image) => image,
    );
  if (definition.layout) config.layout = definition.layout;
  return config;
}
// Le positionneur exporte xPct/yPct/wPct/hPct en coordonnées absolues.
// Les coordonnées relatives, lorsqu'elles existent, sont dans box.parent.
export function boxRect(box, boxes, seen = new Set()) {
  if (seen.has(box.id)) return null;
  const rel = box.parent;
  const parent =
    rel?.parentId != null ? boxes.find((b) => b.id === rel.parentId) : null;
  if (!parent) return { x: box.xPct, y: box.yPct, w: box.wPct, h: box.hPct };
  seen.add(box.id);
  const p = boxRect(parent, boxes, seen);
  if (!p) return null;
  return {
    x: p.x + (p.w * rel.xPct) / 100,
    y: p.y + (p.h * rel.yPct) / 100,
    w: (p.w * rel.wPct) / 100,
    h: (p.h * rel.hPct) / 100,
  };
}
